import { BulkActionProgressList, RecipeProgressList } from '../../types/reducers/progress'

export const SET_BULK_ACTION_PROGRESS = 'SET_BULK_ACTION_PROGRESS'
export const SET_RECIPE_PROGRESS = 'SET_RECIPE_PROGRESS'

export interface SetBulkActionProgress {
    type: typeof SET_BULK_ACTION_PROGRESS
    progress: BulkActionProgressList
    receivedAt: number
}

export interface SetRecipeProgress {
    type: typeof SET_RECIPE_PROGRESS
    progress: RecipeProgressList
    receivedAt: number
}

export type ProgressAction = SetBulkActionProgress | SetRecipeProgress
